<template>
  <div id="error_page">
    <div class="mb-xl">
      <img src="../../assets/img/wave_logo.png" width="100" />
    </div>
    <div class="text-lg">
      <div class="mb-md">ただいまメンテナンス中です。</div>
      <div>2019/12/27（金）18:00 - 2020/01/03（金）10:00</div>
      <div>
        緊急の場合は<a href="mailto:support@alphaus.cloud" target="_blank">support@alphaus.cloud</a
        >までご連絡ください。
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  computed: {
    now() {
      return moment().format('YYYY MM DD HH:mm:ss');
    },
  },
  beforeCreate() {
    document.body.style.backgroundColor = '#f1f1f1';
    document.body.style.fontFamily = 'Helvetica Neue", Helvetica, Arial, sans-serif';
    // change body:before style
    var style = document.createElement('style');
    style.innerHTML = 'body:before{background:none}';
    document.head.appendChild(style);
  },
};
</script>
